import axios from "@/plugins/axios";

let url = "/api/v1/me/orders";

export default {
    getOrders(){
        return axios.get(url).then(result => result.data);
    },
    getOrder(data){
        return axios.get(`${url}/${data._id}`).then(result => result.data);
    }
}
